(() => {
  const root = document.getElementById('tp-home');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  /* shrink any big headline that doesn't fit its box (never break inside a word) */
  const FIT = '.tp-disp, .tp-feat h3, .tp-vs b, .tp-santa h3';
  const fit = (els = root.querySelectorAll(FIT)) => {
    root.classList.add('tp-measuring'); // measure words upright, not mid-animation
    els.forEach(el => {
      el.style.fontSize = '';
      let fs = parseFloat(getComputedStyle(el).fontSize), n = 0;
      while (el.scrollWidth > el.clientWidth + 1 && n++ < 40) { fs *= .95; el.style.fontSize = fs + 'px'; }
    });
    root.classList.remove('tp-measuring');
  };
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(() => fit());
  let ft; addEventListener('resize', () => { clearTimeout(ft); ft = setTimeout(() => fit(), 150); });

  /* reveal on scroll */
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: .12 });
  root.querySelectorAll('.tp-rv').forEach(el => io.observe(el));

  /* snow */
  const cv = root.querySelector('.tp-snow');
  if (cv && !reduce) {
    const ctx = cv.getContext('2d'); let W, H, flakes = [], on = true;
    const size = () => { const r = cv.getBoundingClientRect(), d = Math.min(devicePixelRatio || 1, 2); W = r.width; H = r.height; cv.width = W * d; cv.height = H * d; ctx.setTransform(d, 0, 0, d, 0, 0);
      flakes = Array.from({ length: Math.round(W / 14) }, () => ({ x: Math.random() * W, y: Math.random() * H, r: 1.5 + Math.random() * 3.5, s: .3 + Math.random() * .9, o: Math.random() * 6.28 })); };
    size(); addEventListener('resize', size);
    new IntersectionObserver(([e]) => on = e.isIntersecting).observe(cv);
    let mx = 0; cv.parentElement.addEventListener('pointermove', e => { mx = (e.clientX / innerWidth - .5) * 1.2; });
    (function f(t) {
      if (on) { ctx.clearRect(0, 0, W, H); ctx.fillStyle = '#fff'; ctx.strokeStyle = 'rgba(0,0,0,.18)';
        for (const p of flakes) { p.y += p.s; p.x += Math.sin(t / 1400 + p.o) * .35 + mx; if (p.y > H + 5) { p.y = -5; p.x = Math.random() * W; } if (p.x > W + 5) p.x = -5; if (p.x < -5) p.x = W + 5;
          ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.28); ctx.fill(); ctx.stroke(); } }
      requestAnimationFrame(f);
    })(0);
  }

  /* tickers (speed up with scroll) */
  const words = ['Fall softer', 'Look cuter', 'Ski & snowboard', 'One size fits most', 'Soft landings', 'Most noticed on the mountain'];
  const tracks = [...root.querySelectorAll('.tp-track')].map(t => { const h = words.map(w => `<span>${w}</span><i>✱</i>`).join(''); t.innerHTML = h + h + h + h; return { el: t, dir: +t.dataset.dir, x: 0 }; });
  let lastY = scrollY, vel = 0;
  (function tick() {
    const dy = scrollY - lastY; lastY = scrollY; vel += (dy - vel) * .12;
    if (!reduce) tracks.forEach(t => { t.x -= t.dir * (.8 + Math.abs(vel) * .4); const q = t.el.scrollWidth / 4; if (t.x < -q) t.x += q; if (t.x > 0) t.x -= q; t.el.style.transform = `translateX(${t.x}px)`; });
    requestAnimationFrame(tick);
  })();

  /* fall-o-meter */
  const r = document.getElementById('tp-falls');
  if (r) {
    const mouth = document.getElementById('tp-mouth'), face = document.getElementById('tp-face');
    const upd = () => { const n = +r.value;
      document.getElementById('tp-count').textContent = n;
      document.getElementById('tp-ouch').textContent = n + (n === 1 ? ' ouch' : ' ouches');
      document.getElementById('tp-soft').textContent = n + (n === 1 ? ' soft landing' : ' soft landings');
      const k = Math.min(1, n / 20); mouth.setAttribute('d', `M44 82q16 ${14 - k * 26} 32 0`);
      face.style.transform = `rotate(${(k - .3) * 16}deg) scale(${1 + k * .08})`;
      fit(root.querySelectorAll('.tp-vs b')); };
    r.addEventListener('input', upd); upd();
  }

  /* draggable stickers (desktop) */
  const col = document.getElementById('tp-collage');
  if (col && fine && innerWidth > 1000) {
    let z = 10;
    col.querySelectorAll('.tp-sticker').forEach(st => {
      st.addEventListener('pointerdown', e => {
        e.preventDefault(); st.setPointerCapture(e.pointerId); st.style.zIndex = ++z;
        const cr = col.getBoundingClientRect(), sr = st.getBoundingClientRect(), ox = e.clientX - sr.left, oy = e.clientY - sr.top;
        const move = ev => { st.style.left = (ev.clientX - cr.left - ox) + 'px'; st.style.top = (ev.clientY - cr.top - oy) + 'px'; };
        const up = () => { st.removeEventListener('pointermove', move); st.removeEventListener('pointerup', up); };
        st.addEventListener('pointermove', move); st.addEventListener('pointerup', up);
      });
    });
  }

  /* copy discount code */
  const cp = document.getElementById('tp-copy');
  if (cp) cp.addEventListener('click', async () => { try { await navigator.clipboard.writeText(cp.dataset.code); cp.textContent = 'Copied ✓'; } catch (e) { cp.textContent = cp.dataset.code; } setTimeout(() => cp.textContent = 'Copy', 1800); });

  /* delivery estimate (same windows the product page shows: ready in 1–2 days, delivered in 10–12) */
  const fmt = d => d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
  root.querySelectorAll('#tp-ship b[data-d]').forEach(b => {
    const [a, c] = b.dataset.d.split('-').map(Number); if (!a && !c) return;
    const d1 = new Date(); d1.setDate(d1.getDate() + a); const d2 = new Date(); d2.setDate(d2.getDate() + (c || a));
    b.textContent = c ? `${fmt(d1)} – ${fmt(d2)}` : fmt(d1);
  });
})();